import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "cross",
  "use": "cross-usage",
  "viewBox": "0 0 22.306 18.132",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22.306 18.132\" id=\"cross\"><g data-name=\"Group 2923\" fill=\"none\" stroke=\"#866833\" stroke-linecap=\"square\" stroke-linejoin=\"round\" stroke-width=\"2\"><path data-name=\"Line 33\" d=\"m1.405 1.404 19 15\" /><path data-name=\"Line 34\" d=\"m1.405 16.73 19.5-14.826\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol